import React, { useState, useEffect } from 'react';
import '../styles/ContactHero.css';
// Import contact icons from assets
import callIcon from '../assets/call.webp';
import whatsappIcon from '../assets/watsapp.png';
import emailIcon from '../assets/gmail.png';
import locationIcon from '../assets/map.png';

const ContactHero = () => {
  const contactOptions = [
    { 
      icon: callIcon, 
      title: 'Phone', 
      detail: '033-23240508', 
      link: 'tel:03323240508', 
      alt: 'Call Icon'
    },
    { 
      icon: whatsappIcon, 
      title: 'WhatsApp', 
      detail: '+91 9748691530', 
      link: 'https://wa.me/919748691530', 
      alt: 'WhatsApp Icon'
    },
    { 
      icon: emailIcon, 
      title: 'Email', 
      detail: 'info@paplhear.com', 
      link: 'mailto:info@paplhear.com', 
      alt: 'Email Icon'
    }
  ];

  return (
    <section id="contact-hero" className="contact-hero-section">
      
      {/* Solid Background - No Background Images */}
      <div className="contact-hero-background-solid">
        <div className="contact-hero-overlay-solid"></div>
      </div>

      <div className="contact-hero-container">
        
        {/* Content Wrapper */}
        <div className="contact-hero-content-wrapper">
          
          {/* Left Content */}
          <div className="contact-hero-content">
            <div className="contact-hero-badge">
              <span>Get in Touch</span>
            </div>
            
            <h1 className="contact-hero-title">
              We'd Love to <span>Hear From You</span>
            </h1>
            
            <p className="contact-hero-description">
              Whether you have questions about partnerships, bulk orders, 
              or our products — our team is ready to assist you.
            </p>
            
            <div className="contact-hero-contact-grid">
              {contactOptions.map((option, index) => (
                <a 
                  key={index}
                  href={option.link}
                  className="contact-hero-contact-card"
                  target={option.title === 'WhatsApp' ? '_blank' : '_self'}
                  rel={option.title === 'WhatsApp' ? 'noopener noreferrer' : ''}
                >
                  <div className="contact-hero-contact-icon">
                    <img src={option.icon} alt={option.alt} />
                  </div>
                  <div className="contact-hero-contact-details">
                    <span className="contact-hero-contact-label">{option.title}</span>
                    <span className="contact-hero-contact-value">{option.detail}</span>
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Right Card - Contact Summary */}
          <div className="contact-hero-card">
            <div className="contact-hero-card-icon">
              <img src={locationIcon} alt="Location Icon" />
            </div>
            <h3>Visit Our Office</h3>
            <p>
              Preferred Audiology Pvt. Ltd.<br />
              Ecospace Business Towers, Tower 5A,<br />
              Office no. 508, 5th Floor, New Town,<br />
              Kolkata - 700160
            </p>
            <div className="contact-hero-card-divider"></div>
            <div className="contact-hero-card-hours">
              <div className="contact-hero-card-hour">
                <span>🕐</span>
                <div>
                  <strong>Business Hours</strong>
                  <p>Monday - Saturday: 10:00 AM - 6:00 PM</p>
                </div>
              </div>
              <div className="contact-hero-card-hour">
                <span>⏱️</span>
                <div>
                  <strong>Response Time</strong>
                  <p>Within 24 hours</p>
                </div>
              </div>
            </div>
            <div className="contact-hero-card-badge">
              ✨ We respond within 24 hours ✨
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactHero;